<div [tooltip]="warning" tooltipPosition="bottom" [tooltipOffset]="5" [tooltipDisabled]="!warning" [class.flex-justify-center]="centered" class="pad-0-M horizontal-bar-L flex-align-center" style="gap: 2px" [class]="'color-' + color" [style.color]="warning ? '#F79939' : undefined" [style.border]="warning ? '1px solid #F90' : undefined" [style.background]="warning ? '#FFFFFF' : undefined">
	<img *ngIf="warning" src="assets/icons/warning-triangle.svg" width="14">
	<span>
		<ng-content></ng-content>
	</span>
</div>
